import React from 'react'

const logoH = require("./../../../assets/images/logo/logoNameHoriz.png")

const Footer = () => (
    <footer className="ft" id="contact">
        <div className="wrap">
            <img className="logo" src={logoH} alt="ده‌وند" />
            <div>
                <div className="row"><span className="material-icons">phone</span><a href="tel:09389690438">09389690438</a></div>
                <div className="row"><span className="material-icons">mail</span><a href="mailto:dehvand.tpel@gmail.com">dehvand.tpel@gmail.com</a></div>
            </div>
        </div>
    </footer>
)

export default Footer
